import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import DeveloperSalesTable from "../../components/Users/DeveloperSalesTable";



const DeveloperSalesPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Developer Sales" />

        {/* Users Table */}
        <DeveloperSalesTable />

      </MasterLayout>
    </>
  );
};

export default DeveloperSalesPage;
